var React = require('react');

function Laptop (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M7.5 9A1.5 1.5 0 006 10.5v21a1.5 1.5 0 01-3 0v-21A4.5 4.5 0 017.5 6h33a4.5 4.5 0 014.5 4.5v21a1.5 1.5 0 01-3 0v-21A1.5 1.5 0 0040.5 9h-33z","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0 31.5A1.5 1.5 0 011.5 30h17.332a1.5 1.5 0 011.302.756 4.452 4.452 0 007.732 0A1.5 1.5 0 0129.168 30H46.5a1.5 1.5 0 011.5 1.5v3a7.5 7.5 0 01-7.5 7.5h-33A7.5 7.5 0 010 34.5v-3zM3 33v1.5A4.5 4.5 0 007.5 39h33a4.5 4.5 0 004.5-4.5V33H29.976a7.452 7.452 0 01-11.951 0H3z","key":1})]);
}

Laptop.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = Laptop;

Laptop.default = Laptop;
